import React from 'react';
import { Routes, Route } from 'react-router-dom';

import NavCTA from '../shared/NavigateCTA';
import NavError from '../shared/NavigateError';

import LayoutUNK from '../default/unk/components/Layout';
import ErrorUNK from '../default/unk/components/ErrorPage';

import Layout from '../default/generic/components/Layout';
import Error from '../default/generic/components/ErrorPage';
import Unsub from '../default/generic/components/UnsubscribePage';

import l10nAM from '../default/am/l10n';
import l10nAR from '../default/ar/l10n';
import l10nBO from '../default/bo/l10n';
import l10nCH from '../default/ch/l10n';
import l10nPS from '../default/ps/l10n';
import l10nIQ from '../default/iq/l10n';
import l10nID from '../default/id/l10n';
import l10nJO from '../default/jo/l10n';
import l10nUA from '../default/ua/l10n';
import l10nMA from '../default/ma/l10n';

function DefaultApp() {
  return (
    <Routes>
      <Route path="/" element={<LayoutUNK />}>
        <Route index element={<NavError />} />
        <Route path="*" element={<NavError />} />
        <Route path="error" element={<ErrorUNK />} />
      </Route>
      <Route path="am" element={<Layout market="am" l10n={l10nAM} />}>
        <Route index element={<NavCTA />} />
        <Route path="*" element={<NavError />} />
        <Route path="error" element={<Error />} />
        <Route path="unsubscribe" element={<Unsub />} />
      </Route>
      <Route path="ar" element={<Layout market="ar" l10n={l10nAR} />}>
        <Route index element={<NavCTA />} />
        <Route path="*" element={<NavError />} />
        <Route path="error" element={<Error />} />
        <Route path="unsubscribe" element={<Unsub />} />
      </Route>
      <Route path="bo" element={<Layout market="bo" l10n={l10nBO} />}>
        <Route index element={<NavCTA />} />
        <Route path="*" element={<NavError />} />
        <Route path="error" element={<Error />} />
        <Route path="unsubscribe" element={<Unsub />} />
      </Route>
      <Route path="ch" element={<Layout market="ch" l10n={l10nCH} />}>
        <Route index element={<NavCTA />} />
        <Route path="*" element={<NavError />} />
        <Route path="error" element={<Error />} />
        <Route path="unsubscribe" element={<Unsub />} />
      </Route>
      <Route path="ps" element={<Layout market="ps" l10n={l10nPS} />}>
        <Route index element={<NavCTA />} />
        <Route path="*" element={<NavError />} />
        <Route path="error" element={<Error />} />
        <Route path="unsubscribe" element={<Unsub />} />
      </Route>
      <Route path="iq" element={<Layout market="iq" l10n={l10nIQ} />}>
        <Route index element={<NavCTA />} />
        <Route path="*" element={<NavError />} />
        <Route path="error" element={<Error />} />
        <Route path="unsubscribe" element={<Unsub />} />
      </Route>
      <Route path="id" element={<Layout market="id" l10n={l10nID} />}>
        <Route index element={<NavCTA />} />
        <Route path="*" element={<NavError />} />
        <Route path="error" element={<Error />} />
        <Route path="unsubscribe" element={<Unsub />} />
      </Route>
      <Route path="jo" element={<Layout market="jo" l10n={l10nJO} />}>
        <Route index element={<NavCTA />} />
        <Route path="*" element={<NavError />} />
        <Route path="error" element={<Error />} />
        <Route path="unsubscribe" element={<Unsub />} />
      </Route>
      <Route path="ua" element={<Layout market="ua" l10n={l10nUA} />}>
        <Route index element={<NavCTA />} />
        <Route path="*" element={<NavError />} />
        <Route path="error" element={<Error />} />
        <Route path="unsubscribe" element={<Unsub />} />
      </Route>
      <Route path="ma" element={<Layout market="ma" l10n={l10nMA} />}>
        <Route index element={<NavCTA />} />
        <Route path="*" element={<NavError />} />
        <Route path="error" element={<Error />} />
        <Route path="unsubscribe" element={<Unsub />} />
      </Route>
    </Routes>
  );
}

export default DefaultApp;
